<template>
  <component :is="currentComponent" :key="etapeKey" :parcours="parcours" :tag="tag" :data_etape0="data_etape0" :paragraphId="paragraphId" @switchToEtape1="$emit('switchToEtape1')" @switchToEtape2="$emit('switchToEtape2')" @switchToEtape3="$emit('switchToEtape3')" @switchToEtape4="$emit('switchToEtape4')" @switchToEtape5="$emit('switchToEtape5')" />
</template>

<script setup>
import { ref } from 'vue';
import { onMounted, nextTick } from 'vue';
import Etape3Inner from './Etape3Inner.vue';
import { taggage, taggageView, resetTag } from '@/utils/taggage.js';


defineProps({
  data_etape0: Object,
  paragraphId: Number,
  parcours: Object,
  tag: Object
});

const currentComponent = ref(Etape3Inner);

const etapeKey = ref(0);

defineEmits(['switchToEtape1','switchToEtape2','switchToEtape3','switchToEtape4','switchToEtape5']);


onMounted(async () => {
  //console.log('Etape3 mounted');
  resetTag(3);
  taggage('configurateur_open', 'etape_3', 'display', { tealium_event: 'select_content' });
  //taggageView('XXXX', 'Orange', 'XXXX', 'portail', 'RES', 'global', 'XXXX', 'configurateur_etape_3', 'XXXX', 'Pack Open', 'internet', 'XXXX');
  taggageView('mobile web', 'Orange', '', 'portail', 'RES', 'global', 'configurateur_etape_3', 'Pack Open', 'internet', window.devicePixelRatio);
  // nextTick(() => {
  //   setTimeout(() => {
  //     window.scrollTo({ top: 0 });
  //   }, 0);
  // });
})


</script>
